<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="showModal"
      title="Contact Us"
      @ok="() => (showModal = false)"
    >
      <template slot="footer">
        <button
          key="cancel"
          @click="showModal = false"
          :style="{
            background: '#fff',
            color: '#000',
            padding: '10px 40px',
            'border-radius': '8px',
            border: '1px solid ' + getPrimaryColor(),
          }"
          >Cancel</button
        >
        <a-button
          key="submit"
          type="primary"
          :disable="!topicType"
          @click="submitFeedBack"
          class="primary-button ml-4"
          :style="{
            background: topicType
              ? getPrimaryColor()
              : 'rgba(196, 205, 214, 0.60)',
            padding: '10px 40px',
            'border-radius': '8px',
            border: '1px solid ' + getPrimaryColor(),
          }"
          >Submit</a-button
        >
      </template>
      <p class="description mb-4">
        Tell us how we can improve our product. Your feedback is valuable.
      </p>
      <p
        class="description font-weight-bold"
        :style="{
          'font-size': '14px'
        }"
      >
        Select Topic
      </p>
      <div>
        <a-radio-group
          class="d-flex flex-column radio-group"
          v-model="topicType"
          @change="handleRadioButtons"
        >
          <a-radio class="mb-3" :value="1">
            <span> Missing something</span>
          </a-radio>
          <a-radio class="mb-3" :value="2">
            <span> Improvement idea</span>
          </a-radio>
          <a-radio class="mb-3" :value="3">
            <span> Other</span>
          </a-radio>
        </a-radio-group>
      </div>
      <div>
        <label
          class=" font-weight-bold"
          :style="{
            'font-size': '14px'
          }"
          >Message</label
        >
        <a-textarea
          v-model="topicMessage"
          placeholder="Provide Message"
          :auto-size="{ minRows: 5 }"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
// import { eventBus } from '../../main'
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const AppRepository = RepositoryFactory.get("app");

export default {
  name: "ReportContent",
  data() {
    return {
      showModal: false,
      topicType: null,
      topicMessage: ""
    };
  },
  methods: {
    show(data) {
      this.showModal = true;
      this.user = data;
    },
    hide() {
      this.showModal = false;
    },
    handleRadioButtons(e) {
     
      this.topicType = e.target.value;
    },
    /**
     * Remove User form Circle
     */
    submitFeedBack() {
      const payload = {
        user: this.authUser.user.id,
        role: this.authUser.user.role,
        circle: this.currentCircle.id,
        message: this.topicMessage,
        choice: this.topicType
      };
      AppRepository.postFeedBack(payload)
        .then(res => {
          this.hide();
          this.$notification.success({
            message: "Success",
            description: "Feedback submitted successfully"
          });
        })
        .catch(err => {
          this.hide();
          this.$notification.success({
            message: "Error",
            description: "Something went wrong while submitting"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.description {
  font-size: 16px;
  line-height: 24px;
}
.radio-group {
  margin-bottom: 30px;
  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/contactSupportModal.vue